export const matchSetter = (
  itemName: string,
  setter: any,
  prevValue: string | undefined,
  pathname: string,
  attributeToSet?: string
) => {
  const routeRegex = new RegExp(`\\/(${itemName})\\/(\\d+|new)`, 'mi');

  const matches = pathname.match(routeRegex);

  if (!!matches) {
    const matchedItem = matches[2];

    if (matchedItem !== prevValue) {
      setter({ [`${attributeToSet || itemName}Id`]: matchedItem });
    }
  } else {
    setter({ [itemName]: undefined });
  }
};
